/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

/**
 * This file is the entry point for the `non-pwa.js` script which is loaded on
 * desktop environments by `/web/app/loader.js`.
 */

import stylesheet from './stylesheet.scss' // eslint-disable-line no-unused-vars

import Cart from './pages/cart'
import Header from './pages/header'
import CheckoutConfirmation from './pages/checkout-confirmation'

import {EVENT_ACTION} from 'progressive-web-sdk/dist/analytics/data-objects/'
import {sendPurchaseEvent, sendCartEvent} from './engagement-engine-analytics'

// Push Messaging
import {initMessaging} from 'progressive-web-sdk/dist/non-pwa/messaging'
import defaultAskHtml from './default-ask.html'

const wwwOrigin = window.location.origin.includes('staging') ?
    'https://staging-pwa-carparts.usautoparts.com' :
    'https://www.carparts.com'

const messagingConfiguration = {
    defaultAsk: {
        html: defaultAskHtml,
        auto: window.location.origin === wwwOrigin,
        showOnPageCount: 3,
        deferOnDismissal: 3
    }
}

const monitorUserActionsForCartAbandonment = () => {
    if (Cart.isActivePage()) {
        if (Cart.hasDeletedItem()) {
            // For example, the page url: /basket/?deleteitem=187493783&removeSku=
            // By this time, the remove-from-cart has just happened on desktop
            sendCartEvent(EVENT_ACTION.removeFromCart, Header.cartQty())

        } else if (Cart.hasAddedItem()) {
            // Page url is /basket/?ai=true
            // By this time, the add-to-cart has just happened on desktop
            sendCartEvent(EVENT_ACTION.addToCart, Header.cartQty())
        }

    } else if (CheckoutConfirmation.isActivePage()) {
        sendPurchaseEvent(CheckoutConfirmation.getPurchaseDetails())
    }
}

/**
 * This is called after this script file has successfully loaded, and must exist
 * on `window.Mobify.NonPWA`. Include your own methods if needed.
 */
const init = () => {
    // This initializes the Push Messaging feature, including the default ask
    // iframe which prompts visitors to subscribe.
    initMessaging(messagingConfiguration)

    monitorUserActionsForCartAbandonment()
}

window.Mobify = window.Mobify || {}
window.Mobify.NonPWA = {
    init
}




// WEBPACK FOOTER //
// ./non-pwa/non-pwa.js